var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuizIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quiz-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2727",
    "data-name": "Rectangle 2727",
    width: 15,
    height: 15,
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_363",
    "data-name": "Mask Group 363",
    clipPath: "url(#quiz-icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_48_",
    "data-name": "svgexport-6 (48)",
    transform: "translate(0 0.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4418",
    "data-name": "Group 4418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8466",
    "data-name": "Path 8466",
    d: "M14.116,10.575H9.254A3.051,3.051,0,0,0,7.5,11.13a3.051,3.051,0,0,0-1.757-.555H.879v1.757H0v.879H5.74a.44.44,0,0,1,.439.439v.439H8.815V13.65a.44.44,0,0,1,.439-.439h5.74v-.879h-.879Z",
    transform: "translate(0 -0.911)",
    fill: "#6a6f73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8467",
    "data-name": "Path 8467",
    d: "M6.529,8.7,7.5,9.989,8.466,8.7a3.954,3.954,0,1,0-1.937,0ZM7.936,7.061H7.058V6.182h.879ZM7.5,2.668a1.318,1.318,0,0,1,.781,2.379.842.842,0,0,0-.342.675l-.879.021a1.734,1.734,0,0,1,.7-1.4.439.439,0,1,0-.7-.354H6.179A1.319,1.319,0,0,1,7.5,2.668Z",
    transform: "translate(0 -0.911)",
    fill: "#6a6f73"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizIcon);
export default __webpack_public_path__ + "static/media/quiz-icon.a3f2c86ec5cd80cddee10cf351fe8f1f.svg";
export { ForwardRef as ReactComponent };